import Project1 from "../../assets/js-1.png";
import Project2 from "../../assets/js-2.png";
import Project3 from "../../assets/js-3.png";
import Project4 from "../../assets/react-1.png";
import Project5 from "../../assets/react-2.png";
import Project6 from "../../assets/react-3.png";

export const projectsData = [
  {
    id: 1,
    image: Project1,
    title: "Add-To-Cart",
    category: "Javascript",
    link: "https://my-groceriiis.netlify.app/",
  },
  {
    id: 2,
    image: Project2,
    title: "Portfolio",
    category: "Javascript",
    link : "https://shashiii-portfolio.netlify.app/",
  },
  {
    id: 3,
    image: Project3,
    title: "Stopwatch",
    category: "Javascript",
    link: "https://stoppwaatch.netlify.app/",
  },
  {
    id: 4,
    image: Project4,
    title: "Tenzies Game",
    category: "React",
    link: "https://tennziess-game.netlify.app/",
  },
  {
    id: 5,
    image: Project5,
    title: "Tic Tac Toe Game",
    category: "React",
    link : "https://tict-tact-toet.netlify.app/",
  },
  {
    id: 6,
    image: Project6,
    title: "Investment Calculator",
    category: "NodeJs",
    link : "https://investo-calci.netlify.app/",
  },
];

export const projectsNav = [
  {
    name: "All",
  },
  {
    name: "React",
  },
  {
    name: "Javascript",
  },
  {
    name: "Nodejs",
  },
];
